import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useClockStore = defineStore('clock', () => {
  const now = ref(new Date())

  setInterval(() => {
    now.value = new Date()
  }, 1000)

  return { now }
})
